import { ViewRoute } from "./types";
import { RouteNames } from "@dcc/router/definitions";

export const DaysOfWeekRoute: ViewRoute = {
  [RouteNames.daysOfWeek]: () => {
    return RouteNames.drinksPerWeekDay;
  }
};
